import { Card } from 'primereact/card';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import Map, { Source, Layer, Marker, Popup, NavigationControl } from 'react-map-gl/maplibre';
import 'maplibre-gl/dist/maplibre-gl.css';
import { t } from 'i18next';
import { SelectButton, Button } from 'primereact';
import { DirectionType } from '../../model/enum/DirectionType';
import finishIcon from '../../components/base/finish.svg';
import startIcon from '../../components/base/start.svg';
import ActionButton from '../../components/ActionButton';

export const DashboardCardMapComponentV2 = ({ title, initialRoutes, onFullScreenMap }) => {
    const [routes, setRoutes] = useState(initialRoutes.filter(route => route.direction === DirectionType.TO_WORK));
    const [direction, setDirection] = useState({ name: t('DirectionType.TO_WORK'), type: 'TO_WORK' });
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [popupPosition, setPopupPosition] = useState(null);
    const mapRef = useRef();
    useEffect(() => {
    }, [routes]);
    const directionText = (direction) => {
        switch (direction) {
            case DirectionType.FROM_WORK:
                return t('DirectionType.FROM_WORK');
            case DirectionType.TO_WORK:
                return t('DirectionType.TO_WORK');
            default:
                return t('DirectionType.UNSET');
        }
    };

    const directions = [
        { name: t('DirectionType.FROM_WORK'), type: DirectionType.FROM_WORK },
        { name: t('DirectionType.TO_WORK'), type: DirectionType.TO_WORK },
        { name: t('DirectionType.UNSET'), type: DirectionType.UNSET }
    ];

    const calculateBounds = (routes) => {
        const coordinates = routes.flatMap(route => route.coordinates);
        const longitudes = coordinates.map(c => c.longitude);
        const latitudes = coordinates.map(c => c.latitude);
        const minLon = Math.min(...longitudes);
        const maxLon = Math.max(...longitudes);
        const minLat = Math.min(...latitudes) - 0.02;
        const maxLat = Math.max(...latitudes) + 0.02;
        return [[minLon, minLat], [maxLon, maxLat]];
    };
    let userRoutesBounds = null;
    const updateRoutes = (e) => {
        const type = e.value?.type;
        const routesToInititate = initialRoutes.filter(route => {
            if (type === DirectionType.UNSET) {
                return route.direction !== DirectionType.TO_WORK && route.direction !== DirectionType.FROM_WORK;
            } else {
                return route.direction === type;
            }
        });
        setDirection(e.value);
        setRoutes(routesToInititate);
    };
    if (routes && routes.length > 0) {
        userRoutesBounds = calculateBounds(routes);
    }
    const handleRouteClick = (route, coordinates) => {
        setSelectedRoute(route);
        setPopupPosition(coordinates);
    };
    const getRouteIndexFromSourceParam = (feature) => {
        const str = feature.source ;
        const number = str.match(/\d+/); 
        return number;
    }
    const handleMouseMove = (event) => {
        const map = mapRef.current.getMap();
        const features = map.queryRenderedFeatures(event.point, {
            layers: routes.map((_, i) => `route-layer-${i}`)
        });
        if (features.length > 0) {
            const hoveredFeature = features[0];
            const routeIndex =  getRouteIndexFromSourceParam(hoveredFeature);
            setSelectedRoute(routes[routeIndex]);
            setPopupPosition([event.lngLat.lng,event.lngLat.lat]);
            return;
        }
        setSelectedRoute(null);
        setPopupPosition(null);
    };
    const cardHeader = (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginLeft: '15px', marginRight: '15px'}}>
            <div className="title">{title}</div>
            {onFullScreenMap && (
                <ActionButton
                style={{marginTop: '5px', marginRight: '25px'}}
                    iconName={'mdi-fullscreen'}
                    handleClick={onFullScreenMap}                       
                    tooltip="Powiększ mapę"
                    label="Powiększ mapę"
                />
                
            )}
        </div>
    );

    return (
        <Card className="dashboard-card-map mt-1" header={cardHeader}>
            <SelectButton
                optionLabel="name"
                value={direction}
                options={directions}
                onChange={updateRoutes}
            />
            <Map
                ref={mapRef}
                initialViewState={{
                    longitude: userRoutesBounds ? userRoutesBounds[0][0] : 19.107532,
                    latitude: userRoutesBounds ? userRoutesBounds[0][1] : 52.037049,
                    zoom: userRoutesBounds ? 10 : 5
                }}
                style={{ height: '550px', zIndex: '100' }}
                mapStyle={process.env.REACT_APP_MAP_STYLE}
                bounds={userRoutesBounds}
                onMouseMove={handleMouseMove}
            >
                <NavigationControl position="top-right" />
                {routes.map((route, routeIndex) => {
                    const startPoint = route.coordinates[0];
                    const lastPoint = route.coordinates[route.coordinates.length-1];
                    const routeCoordinates = route.coordinates.map(coo => [coo.longitude, coo.latitude]);
                    return (
                        <div key={routeIndex}>
                            <Source
                                id={`route-source-${routeIndex}`}
                                type="geojson"
                                data={{
                                    type: "FeatureCollection",
                                    features: [
                                        {
                                            id:{},
                                            type: "Feature",
                                            geometry: {
                                                type: "LineString",
                                                coordinates: routeCoordinates
                                            },
                                        }
                                    ]
                                }}
                            >
                                <Layer
                                    id={`route-layer-${routeIndex}`}
                                    type="line"
                                    className="XS"
                                    paint={{
                                        'line-color': '#0000FF',
                                        'line-width': 4
                                    }}
                                />
                            </Source>
                            <Marker
                                longitude={startPoint.longitude}
                                latitude={startPoint.latitude}
                                anchor="bottom"
                                offsetLeft={-16}
                                offsetTop={-32}
                                onClick={() => handleRouteClick(route, [startPoint.longitude, startPoint.latitude])}                            
                                >
                                <img src={startIcon} alt="Start Icon" width={32} height={32} />
                            </Marker> 
                            <Marker
                                longitude={lastPoint.longitude}
                                latitude={lastPoint.latitude}
                                anchor="bottom"
                                offsetLeft={-16}
                                offsetTop={-32}
                                onClick={() => handleRouteClick(route, [lastPoint.longitude, lastPoint.latitude])}                            
                                >
                                <img src={finishIcon} alt="end Icon" width={32} height={32} />
                            </Marker>
                            {selectedRoute === route && (
                                <Popup
                                    longitude={popupPosition[0]}
                                    latitude={popupPosition[1]}
                                    closeButton={false}
                                    closeOnClick={false}
                                    anchor="top"
                                >
                                    <div className="row">
                                        <div className="col-12">
                                            <b> {t('global.user')}:</b> {route.user.fullName}
                                        </div>
                                        <div className="col-12">
                                            <b>{t('global.transportName')}:</b> {route.transport.name}
                                        </div>
                                        <div className="col-12">
                                            <b>{t('global.direction')}:</b> {directionText(route.direction)}
                                        </div>
                                    </div>
                                </Popup>
                            )}
                        </div>
                    );
                })}
            </Map>
        </Card>
    );
};

DashboardCardMapComponentV2.defaultProps = {
    initialRoutes: [],
};

DashboardCardMapComponentV2.propTypes = {
    title: PropTypes.string.isRequired,
    initialRoutes: PropTypes.array.isRequired,
    onFullScreenMap: PropTypes.func,
};

export default withTranslation()(DashboardCardMapComponentV2);